import { Order as OrderTypes } from '@luxuryescapes/contract-svc-order'

function merchandiseShippingItemMap(item: OrderTypes.MerchandiseItem): App.OrderMerchndiseShippingItem {
  return {
    id: item.id,
    total: item.total,
    status: item.status,
    shippingGroupId: (item as any).shipping_group,
    address: {
      company: (item as any)?.address?.company ?? '',
      address: (item as any)?.address?.address ?? '',
      city: (item as any)?.address?.city ?? '',
      state: (item as any)?.address?.state ?? '',
      postcode: (item as any)?.address?.postcode ?? '',
      country: (item as any)?.address?.country ?? '',
    },
  }
}

export default merchandiseShippingItemMap
